import { CircularProgress, Grid } from "@mui/material";
import * as React from "react";
// @ts-ignore
import { useNavigate } from "react-router-dom";
import theme from "../styles/theme";
import { color } from "../styles/color";
import Text from "../styles/textStyles";
import { StyledContentContainerBox } from "../modules/propuesta/propuesta.style";
import WCIcons from "../elements/icons/WCIcons";

function Custom404() {
  const router = useNavigate();
  React.useEffect(() => {
    setTimeout(() => {
      router("/");
    }, 3000);
  }, []);
  return (
    <StyledContentContainerBox
      sx={{
        width: "fit-content",
        [theme.breakpoints.down("mobile")]: {
          borderRadius: "24px",
        },
      }}
    >
      <Grid container direction="column">
        <Grid
          item
          sx={{
            width: "100%",
            // adding padding is a hotfix because of grid inside dialog mess with vertical position and adds a unwanted scrollbar
            [theme.breakpoints.up("xs")]: {
              padding: theme.spacing(12),
            },
            [theme.breakpoints.up("xl")]: {
              padding: theme.spacing(14),
            },
            [theme.breakpoints.down("mobile")]: {
              padding: 5,
            },
          }}
        >
          <Grid container direction="column" alignItems="center" rowSpacing={4}>
            <Grid item>
              <WCIcons name="message-failed" width="50" height="50" />
            </Grid>
            <Grid item>
              <Grid
                container
                direction="column"
                alignItems="center"
                rowSpacing={2}
              >
                <Grid item>
                  <Text size="xl" weight="semibold" align="center">
                    La página no existe
                  </Text>
                </Grid>
                <Grid item>
                  <Text
                    size="xs"
                    weight="medium"
                    fontColor={color.greyscale.black[30]}
                    align="center"
                  >
                    En unos segundos serás redirigido...
                  </Text>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              sx={{
                color: color.turquoise[100],
              }}
            >
              <CircularProgress color="inherit" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledContentContainerBox>
  );
}
Custom404.title = "Página no encontrada";
Custom404.layout = "EmptyLayout";
Custom404.mobileLayout = "MobileEmptyLayout";
export default Custom404;
